import { classNames } from "../../shared/utility";

export default function OperationalTableToolbar({
  className,
  searchRow,
  searchRowClassName,
  filterActions,
  trailing,
  footer,
}) {
  return (
    <div
      className={classNames(
        "relative rounded-t-[18px] border-b border-[#E2E8F0] bg-[#F8FAFC] px-4 py-3 sm:px-5",
        className,
      )}
    >
      <div className="flex flex-col gap-3 sm:flex-row sm:items-center sm:justify-between">
        {searchRow ? (
          <div
            className={classNames(
              "relative min-w-[12rem] w-full sm:max-w-xs",
              searchRowClassName,
            )}
          >
            {searchRow}
          </div>
        ) : null}

        <div className="flex flex-wrap items-center justify-end gap-2 sm:ml-auto">
          {filterActions}
          {trailing ? (
            <div className="flex flex-wrap items-center gap-3">{trailing}</div>
          ) : null}
        </div>
      </div>

      {footer ? (
        <div className="mt-3 border-t border-[#E2E8F0] pt-3">{footer}</div>
      ) : null}
    </div>
  );
}
